// extracted by mini-css-extract-plugin
export var desktop = "hero-image-module--desktop--Zq8Vf";
export var eye_grab = "hero-image-module--eye_grab--McXrS";
export var eye_grab_image = "hero-image-module--eye_grab_image--TGELE";
export var eye_grab_text_container = "hero-image-module--eye_grab_text_container--Hzo7h";
export var mobile = "hero-image-module--mobile--3basi";
export var required_images = "hero-image-module--required_images--D5kAz";
export var top_required_image = "hero-image-module--top_required_image--EUMJl";